<!--
    描述：场地管理  -- 左侧场地table
    时间：2020/10/13
    Created by zl
-->

<template>
  <div class="h100 audit">
    <filter-layout @search="getData" @reset="resetForm" v-if="!routeQuery">
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchForm"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="归属单位：" prop="sceneApply">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchForm.unitName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="场地名称：" prop="createUser">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchForm.sname"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <!-- 头部按钮 -->
        <div class="content-header" v-if="!routeQuery">
          <div class="title">
            场地合计：<span class="blue">{{total}}</span
            >个
          </div>
          <div class="btnGroups">
            <el-button
              class="btn-success"
              size="small"
              @click="operateEntranceGuard('add', {})"
              v-if="roleBtns.includes('entranceGuard-add')"
              >添加场地门禁
            </el-button>
            <el-button
              class="btn-success"
              size="small"
              @click="addPlace('add')"
              v-if="roleBtns.includes('siteMsaintenance-add')"
              >添加场地
            </el-button>
            <!-- <el-button type="primary" class="btn-blue ml10" size="small" @click="changeState">筛选
				<i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
				<i v-else class="el-icon-caret-top ml5"></i>
			  </el-button> -->
            <el-button
              size="small"
              class="btn-blue"
              icon="el-icon-refresh"
              type="primary"
              @click="resetForm"
            ></el-button>
          </div>
        </div>
        <div class="w-table-layout w-table-page" v-if="!routeQuery">
          <div class="w-table-content" v-show="tableShow">
            <el-table
              ref="leftTable"
              border
              height="100%"
              :data="filterData"
              highlight-current-row
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50"
              >
              </el-table-column>
              <el-table-column
                prop="sname"
                label="场地名称"
                header-align="center"
                min-width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="tenantSname"
                label="场地归属单位"
                header-align="center"
                min-width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="detailAdd"
                label="场地地址"
                header-align="center"
                min-width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="详细地址"
                header-align="center"
                min-width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="tagName"
                label="标签"
                header-align="center"
                min-width="150"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.tag == '1001001'">平台场地</span>
                    <span v-else-if="scope.row.tag == '1001002'">自有场地</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="accessDevice"
                label="门禁设备名称"
                header-align="center"
                min-width="150"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div
                    class="table-scope-btn"
                    @click="operateEntranceGuard('view', scope.row)"
                    v-if="scope.row.accessDevice"
                  >
                    {{ scope.row.accessDevice }}
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column width="250" align="center">
                <template slot="header">操作</template>
                <template slot-scope="scope">
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="rowClick(scope.row)"
                  >
                    <!-- <svg-icon icon-class="form-look"></svg-icon> -->
                    详情
                  </el-button>
                  <!-- <el-button
					  type="success"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  :disabled="scope.row.tag == '1001002'"
					  v-if="roleBtns.includes('siteMsaintenance-edit')"
					  @click="editField(scope.row, 'edit')"
					>
					  <svg-icon icon-class="form-edit"></svg-icon>
					  编辑
					</el-button>
					<el-button
					  type="danger"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  icon="el-icon-delete"
					  :disabled="scope.row.tag == '1001002'"
					  v-if="roleBtns.includes('siteMsaintenance-del')"
					  @click.native.stop="deletePlace(scope.row)"
					  >删除
					</el-button> -->
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    :disabled="scope.row.accessDevice == ''"
                    v-if="roleBtns.includes('entranceGuard-edit')"
                    @click="operateEntranceGuard('edit', scope.row)"
                  >
                    <!-- <svg-icon icon-class="form-edit"></svg-icon> -->
                    编辑门禁
                  </el-button>
                  <el-button
                    type="danger"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    :disabled="scope.row.accessDevice == ''"
                    v-if="roleBtns.includes('entranceGuard-delete')"
                    @click.native.stop="deleteEntranceGuard(scope.row.id)"
                  >
                    <!-- icon="el-icon-delete" -->
                    删除门禁
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="w-table-footer">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageList"
              :page-size="pageSize"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </filter-layout>
    <el-dialog
      title="添加场地"
      :visible.sync="dialogVisible"
      width="900px"
      center
      @close="diaClose"
    >
      <el-form
        label-width="130px"
        :model="placeForm"
        :rules="placeRule"
        ref="placeRef"
      >
        <el-row>
          <el-col :span="21" :offset="1">
            <el-form-item label="上级目录">
              <el-input v-model="placeForm.parent" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="21" :offset="1">
            <el-form-item label="场地名称：" prop="sname">
              <el-input
                v-model="placeForm.sname"
                placeholder="请输入场地名称"
                maxlength="6"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="21" :offset="1">
            <el-form-item label="场地所属单位：" prop="unit">
              <el-select
                v-model="placeForm.unit"
                placeholder="请选择场地所属单位"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.sname"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="21" :offset="1">
            <el-form-item label="场地地址：" required class="s-form-item">
              <address-form
                v-model="area"
                :showWordLimit="true"
                :detailMaxLength="8"
              ></address-form>
            </el-form-item>
          </el-col>
          <el-col :span="21" :offset="1">
            <el-form-item label="应用系统：" prop="applySysArr">
              <el-checkbox-group v-model="placeForm.applySysArr">
                <el-checkbox
                  v-for="(item, index) in yyxt"
                  :key="index"
                  :label="item.value"
                >
                  {{ item.sname }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="text-center mt10">
        <el-button size="small" class="btn" @click="dialogVisible = false">
          取消
        </el-button>
        <el-button
          type="primary"
          class="btn btn-blue"
          size="small"
          @click="savePlace"
        >
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 场地门禁 -->
    <el-dialog
      :title="entranceGuardDialog.title"
      :visible.sync="entranceGuardDialog.visible"
      width="900px"
      center
    >
      <entranceGuardDialog
        ref="entranceGuardDialog"
        :entranceGuardRow="entranceGuardRow"
        :entranceGuardType="entranceGuardType"
      ></entranceGuardDialog>
      <div
        slot="footer"
        class="text-center mt10"
        v-if="entranceGuardType != 'view'"
      >
        <el-button
          size="small"
          class="btn"
          @click="entranceGuardDialog.visible = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          class="btn btn-blue"
          size="small"
          @click="saveEntranceGuard"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
	deleteMeetingDoorInfo,
	deleteOperate,
	detailAdd,
	getOperateInfo,
	getoperateMeetingList,
	getOperateSiteList,
	getOperateTenantMapList,
} from "api/modules/fieldManagement";
import addressForm from "components/addressForm/addressForm";
import { mapState } from "vuex";
import XEUtils from "xe-utils";

import entranceGuardDialog from "./entrance-guard-dialog.vue";

export default {
  components: {
    addressForm,
    entranceGuardDialog
  },
  props: {},
  data() {
    return {
      searchToggle: true, //筛选控制
      tableShow: true, //表格显隐控制
      filterData: [], //场地列表
      loading: false,
      dialogVisible: false,
      area: {},
      placeForm: {
        parent: "场地",
        sname: "", //场地名称
        unit: "",
        province: "",
        city: "",
        area: "",
        detailAdd: "",
        tag: "1001001",
        applySysArr: []
      },
      searchForm: {
        unitName: "",
        sname: ""
      },
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      placeRule: {
        sname: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ],
        unit: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ],
        applySysArr: [
          {
            required: true,
            message: "应用系统不能为空",
            trigger: "change"
          }
        ]
      },
      departmentList: [], //场地所属单位列表
      tagList: [],
      selectIndex: 0,
      dialogType: "",
      yyxt: [
        {sname: "安招采", value: "1017001"},
        {sname: "经营", value: "1017002"},
        {sname: "实施", value: "1017003"},
        {sname: "办公OA", value: "1017004"}
      ],

      entranceGuardDialog: {
        visible: false, //对话框是否显示
        title: "新增场地门禁" //标题
      }, // 场地门禁对话框
      entranceGuardRow: {}, //父子组件传参 记录编辑/查看时选中哪一行
      entranceGuardType: "add" //场地门禁对话框状态 区分新增编辑查看
    };
  },
  created() {
    this.getData({currentPage: 1}); //获得场地列表数据
    this.getDepartments();
  },
  methods: {
    // 切换状态
    changeState() {
      this.searchToggle = !this.searchToggle;
    },
    //获得场地列表数据
    getData(obj) {
      if (obj && obj.currentPage) {
        this.currentPage = obj.currentPage;
      }
      this.loading = true;
      let params = {
        unitName: this.searchForm.unitName,
        sname: this.searchForm.sname,
        current: this.currentPage,
        size: this.pageSize
      };
      getOperateSiteList(params)
          .then(res => {
            this.loading = false;
            this.filterData = res.data.records;

            this.total = parseInt(res.data.total);
          })
          .catch(err => {
            this.loading = false;
          });
    },
    resetForm() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.searchForm.sname = "";
      this.searchForm.unitName = "";
      this.getData();
    },

    // 获取所属单位
    getDepartments() {
      getOperateTenantMapList().then(d => {
        if (d.code == 0) {
          this.departmentList = d.data;
        }
      });
    },

    //编辑场地
    editField(params, type) {
      this.dialogType = type;
      this.dialogVisible = true;
      this.getOperateSiteInfo(params);
    },

    // 删除场地
    deletePlace(row) {
      this.$confirm("此操作将永久删除该场地, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            getoperateMeetingList({
              sname: "",
              siteId: row.id,
              current: 1,
              size: 10
            }).then(res => {
              if (res.data.records.length != "0") {
                this.$message.error("该场地下有会议室，无法删除！");
              } else {
                deleteOperate({
                  operateSiteId: row.id
                }).then(d => {
                  this.$message.success(d.msg);
                  this.$emit("on-reset");
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
    },

    // 左侧场地点击
    rowClick(obj) {
      this.$router.push({
        name: "Field-management",
        query: {
          type: "Area"
        }
      });
      this.$emit("reset-right", obj);
      this.$emit("getCompanyId", obj);
    },

    // 添加场地
    addPlace(type) {
      this.dialogType = type;
      this.dialogVisible = true;
    },

    // 保存场地
    savePlace() {
      this.$refs.placeRef.validate(valid => {
        if (valid) {
          if (!this.area.area) {
            this.$message.warning("请选择场地地址！");
            return;
          } else if (!this.area.area.name) {
            this.$message.warning("请选择场地地址！");
            return;
          }
          let params = Object.assign({}, this.placeForm);
          let area = Object.assign({}, this.area);
          params.province = area.province.value;
          params.city = area.city.value;
          params.area = area.area.value;
          params.address = area.detail;
          params.applySys = this.placeForm.applySysArr.join(",");
          params.detailAdd =
              area.province.name + area.city.name + area.area.name;
          detailAdd(params).then(d => {
            this.dialogVisible = false;
            this.$refs.placeRef.resetFields();
            if (this.dialogType == "edit") {
              window.sessionStorage.setItem("companyId", d.data.id);
            }
            this.getData();
          });
        } else {
          this.$message.warning("请检验表单");
        }
      });
    },

    // 获取当前场地的信息
    getOperateSiteInfo(data) {
      getOperateInfo({
        id: data.id
      }).then(d => {
        if (d.code == 0) {
          let params = Object.assign({}, d.data);
          params.area = {};
          params.area.province = {
            value: params.province
          };
          params.area.city = {
            value: params.city
          };
          params.area.area = {
            value: d.data.area
          };
          params.area.detail = params.address;
          params.parent = "场地";
          this.placeForm = params;
          this.area = params.area;
          let arr = params.applySys.split(",");
          this.$set(this.placeForm, "applySysArr", arr);
        }
      });
    },

    // 弹窗关闭
    diaClose() {
      this.selectIndex = this.filterData.findIndex(
          x => x.id == this.placeForm.id
      );
      this.area = {
        province: {
          name: "",
          value: ""
        },
        city: {
          name: "",
          value: ""
        },
        area: {
          name: "",
          value: ""
        },
        detail: ""
      };
      this.$refs.placeRef.resetFields();
      this.placeForm.id = "";
    },

    // 场地门禁 新增/编辑/查看
    operateEntranceGuard(type, row) {
      this.entranceGuardType = type; //记录场地门禁状态 区分新增编辑查看
      this.entranceGuardRow = XEUtils.clone(row, true); //编辑/查看时 传选中行id
      this.entranceGuardDialog.visible = true; //打开对话框
      this.entranceGuardDialog.title =
          this.entranceGuardType == "add"
              ? "新增场地门禁"
              : this.entranceGuardType == "edit"
                  ? "编辑场地门禁"
                  : "查看场地门禁"; //对话框标题
    },
    // 场地门禁 删除
    deleteEntranceGuard(id) {
      this.$confirm("确认要删除当前场地门禁吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            deleteMeetingDoorInfo({
              id: id,
              updateUserid: this.userInfo.id
            }).then(res => {
              if (res.code == 0) {
                const loading = this.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });
                setTimeout(() => {
                  this.getData({currentPage: 1}); // 删除后重新刷新列表
                  loading.close();
                  this.$message.success("删除成功！"); // 删除成功信息
                }, 2000);
              } else {
                this.$message.error(res.msg); // 删除失败
              }
            });
          })
          .catch(() => {
          });
    },
    // 保存 场地门禁对话框
    saveEntranceGuard() {
      this.$refs.entranceGuardDialog.saveEntranceGuard();
    },
    // 保存成功后 关闭对话框并刷新页面
    entranceGuardCloseAndRefresh() {
      this.entranceGuardDialog.visible = false; // 关闭对话框
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        this.getData(); // 保存成功后重新刷新列表
        loading.close();
      }, 2000);
    },

    // 首行选中
    tableRowClassName({row, rowIndex}) {
      if (this.selectIndex === rowIndex) {
        return "high-row";
      }
      return "";
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    }
  },
  computed: {
    routeQuery() {
      return this.$route.query.type;
    },
    ...mapState("user", {
      userInfo: state => state.userInfo
    }),
    ...mapState("place_dict", {
      bq: state => state.bq
    }),
    ...mapState("menu", {
      roleBtns: state => state.roleBtns
    })
  },
  mounted() {
  }
};
</script>
<style lang="less" scoped>
.content-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  .title {
    padding-left: 10px;
    border-left: 4px solid #2671cc;
    font-size: 14px;
    color: #202020;
  }
  .blue{
    font-size: 18px;
    color: #2671cc;
  }
  }
</style>
